import { COLUMN_LOGINS_COUNT, COLUMN_NAME, COLUMN_SITE, COLUMN_TYPE } from "../../constants/column-types";
import { FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const PermissionColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    // {
    //     heading: "Type",
    //     accessor: "type",
    //     isNumeric: false,
    //     id: 1,
    //     active: true,
    //     translationKey: "type",
    //     columnId: COLUMN_TYPE,
    // }, // Not useful for now, but will show Default / Custom in future when supported.
    {
        heading: "Logins",
        accessor: "logins",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "logins",
        columnId: COLUMN_LOGINS_COUNT,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 3,
        active: true,
        // searchOnName: "site.siteName", -- This is not supportted for now
        // lookupName: "site.siteName",
        translationKey: "site",
        // filterId: FILTER_SITES,
        settingDataName: 'site',
        columnId: COLUMN_SITE,
    }
];

export default PermissionColumns;
